export default "__VITE_ASSET__004a302d__"